export enum StudyLevel {
    Bachelor = 1,
    Magistracy = 2,
    Specialty = 3,
    Postgraduate = 4,
    SecondaryProfessionalEducation = 5,
}
